export const environment = {
    production: false,

    ApiBase: "./Usnr.API/usnrapi/",

    ImageLocation: "assets/images/",
    LocalImageLocation: "assets/local-images/",
    DocumentLocation: "assets/documents/",
};
/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
